/**
 * Role-based access control constants for the 24FM Ticket System.
 *
 * PANEL_ROLES – roles that grant full access to every page in the panel.
 * RESTRICTED_EMAILS – emails that may log in but can **only** see the
 *   Movie Ticket page, filtered to RESTRICTED_MOVIE_TITLE.
 */

/** Roles allowed full panel access */
export const PANEL_ROLES: readonly string[] = ["superadmin", "admin", "sell_ticket"];

/**
 * Emails with restricted access (Movie Ticket page only, single movie).
 * Loaded from REACT_APP_RESTRICTED_EMAILS env var (comma-separated).
 */
export const RESTRICTED_EMAILS: readonly string[] = (process.env.REACT_APP_RESTRICTED_EMAILS ?? "")
  .split(",")
  .map((email) => email.trim())
  .filter(Boolean);

/** The only movie title restricted-email users may see */
export const RESTRICTED_MOVIE_TITLE = "ပြုံးပြုံးလေး";
export const RESTRICTED_MOVIE_SLUG = "pyone-pyone-lay";
